module.exports = __webpack_public_path__ + "static/media/Gucci-Multicolor-Gg-Blooms-Supreme-Slide-Sandal-Lyst.ebd8723e.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/products/shoes/Gucci-Multicolor-Gg-Blooms-Supreme-Slide-Sandal-Lyst.png
// module id = 277
// module chunks = 0